<template>
    <div>
      <secondHeader />
      <div class="main">
        <sidebar />
        <div class="tool-content">
          <notice-bar />
          <h1 class="tool-title">配信画面用デジタル時計</h1>

          <div class="clock-list">
            <div @click="openModal('clockapp')" class="clock-preview">
              <div id="clock-model" class="clock-design-grad">
                <span class="clock-date">2022-09-29 THU</span>
                <span class="clock-time">04:12</span>
              </div>
              <h2 class="clock-name">グラデーション時計</h2>
            </div>
            <div @click="openModal('simpleClockapp')" class="clock-preview">
              <div id="clock-model" class="clock-design-simple">
                <span class="clock-date">2022-09-29 THU</span>
                <span class="clock-time">04:12</span>
              </div>
              <h2 class="clock-name">カラー時計</h2>
            </div>
            <div @click="openModal('noBgClock')" class="clock-preview">
              <div id="clock-model" class="clock-design-nobg">
                <span class="clock-date">2022-09-29 THU</span>
                <span class="clock-time">04:12</span>
              </div>
              <h2 class="clock-name">シンプル時計</h2>
            </div>
            <div @click="openModal('bubbleClock')" class="clock-preview">
              <div id="bubble-clock-model" class="clock-design-bubble">
                <span class="bubble-clock-time"><p class="bubble-clock-ampm">am</p>04:12</span>
              </div>
              <h2 class="clock-name">バブル時計</h2>
            </div>

            <div @click="openModal('barClock')" class="clock-preview">
              <div id="bar-clock-model" class="clock-design-bar">
                <span class="bar-clock-time">04:12<span class="bar-clock-ampm">am</span></span>
              </div>
              <h2 class="clock-name">バー時計</h2>
            </div>

            <div @click="openModal('nyanClock')" class="clock-preview">
              <div id="nyan-clock-model">
                <img src="@/assets/thumbnail/nyan-clock.png" alt="NYAN" class="nyan-img">
              </div>
              <h2 class="clock-name">NYAN</h2>
            </div>
          </div>

          <!-- モーダルの表示 -->
          <div v-if="showModal" class="modal" @click="closeModal">
            <div class="modal-content" @click.stop>
              <span class="close" @click="closeModal">&times;</span>
              <component :is="currentComponent" />
            </div>
          </div>

          <div class="ad-block">
            <div class="ad">
              <InFeedAdsense
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-9016794589237931"
                  data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </div>

          <div class="blog-area">
            <h2 class="blog-area-title">使い方はブログでチェック！</h2>
            <div class="blog-area-row">
              <div class="blog-area-thumb">
                  <img class="article-list-img" src="@/assets/article/thumnail_clock.png">
              </div>
              <div class="blog-area-desc">
                <p>具体的な使い方や、おすすめのカスタマイズ方法はブログ記事で紹介しています。あわせてどうぞ！</p>
                <div class="blog-area-btn">
                  <a href="https://www.ruri.info/?p=200" target="_blank" rel="noopener noreferrer">
                    <span class="check-btn">記事をチェック</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue"
import sidebar from "../components/sidebar.vue"
import noticeBar from "../components/notice-bar.vue"
import clockapp from "../components/clock/clockapp.vue"
import simpleClockapp from "../components/clock/simpleClockapp.vue"
import noBgClock from "../components/clock/noBgClockapp.vue"
import bubbleClock from "../components/clock/bubbleClock.vue"
import barClock from "../components/clock/barClock.vue"
import nyanClock from "../components/clock/nyanClock.vue"

export default{
    components:{
        secondHeader,
        sidebar,
        noticeBar,
        clockapp,
        simpleClockapp,
        noBgClock,
        bubbleClock,
        barClock,
        nyanClock,
    },
    data(){
      return{
        isProduction: process.env.NODE_ENV === "production",
        showModal: false,
        currentComponent: null,
      }
    },
    methods: {
      openModal(componentName) {
        this.currentComponent = componentName;
        this.showModal = true;
      },
      closeModal() {
        this.showModal = false;
      }
    }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}

.ad-block{
  padding: 12px 0px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  display: block;
}

.ariticle-btn:hover{
  transform: translateY(-5px);
  box-shadow: 0 7px 34px rgba(50,50,93,.1), 0 3px 6px rgb(0 0 0 / 10%);
}

@media screen and (max-width: 600px) {
  .clock-list{
    display: block;
  }
}


.tool-content{
  margin: 36px auto 0 auto;
  max-width: 960px;
  width: 100%;
  padding: 30px;
}

.tool-content h1{
  text-align: center;
}

.tool-title{
  letter-spacing: 2px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
  font-size: 1.5rem;
  color:#212121;
  font-weight: bold;
}

.clock-list{
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin-top:48px;
}

.clock-name{
  margin-top: 12px;
  letter-spacing: 2px;
  font-size: 1rem;
}

.clock-preview{
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.35);
  background-color: #fafaf9;
  cursor: pointer;
	transition: .3s;
  width: 210px;
  height: auto;
  border-radius: 15px;
  padding: 16px 24px 8px 24px;
  text-align: center;
  margin: 12px auto;
}

.clock-preview:hover {
	box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.35);
	transform: translateY(-4px);
}


#clock-model {
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 12px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  color: #fff;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  white-space: nowrap;
}

#bubble-clock-model{
  width: 160px;
  aspect-ratio: 22 / 18;
  padding: 0px 12px 0px 12px;
  margin: auto;
  border-radius: 80% 30% 50% 50%/50%;
  color: #fff;
  -webkit-align-self: flex-start;
  align-self: flex-start;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

#bar-clock-model {
  width: 130px;
  height: 50px;
  padding: 14px 42px 0px 42px;
  margin: auto;
  margin-top: 20%;
  border-radius: 100vh;
  color: #fff;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

#nyan-clock-model{
  padding: 18px 24px;
  margin: auto;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

.clock-design-grad{
  font-family: "Open Sans", sans-serif;
  background: linear-gradient(260deg, #D9AFD9 0%, #97D9E1 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

.clock-design-simple{
  font-family: "Open Sans", sans-serif;
  background-color:#EF84EC;
}

.clock-design-nobg{
  font-family: "Open Sans", sans-serif;
}

.clock-design-nobg > .clock-time, .clock-design-nobg > .clock-date{
  color: #3064BA;
}

.clock-design-bubble{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;

  background: linear-gradient(260deg, #304352 0%, #d7d2cc 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

.clock-design-bar{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;

  background: linear-gradient(256deg,#0093E9 0%,#a1efc6 46%, #80D0C7 100%);
  background-size: 240% 240%;
  animation: green-gradient-animation 10s ease infinite;
}

.clock-time{
  letter-spacing: 0.05em;
  font-size: 60px;
}

.clock-date{
  padding-top: 12px;
  letter-spacing: 0.1em;
  font-size: 18px;
  display: block;
}

.bubble-clock-time{
  letter-spacing: 0.05em;
  font-size: 45px;
  line-height: 0.75em;
  margin-bottom: 10px;
}

.bubble-clock-ampm{
  font-size: 0.5em;
  margin-right: 0;
  display: flex;
  justify-content: flex-end;
}

.bar-clock-time{
  font-size: 40px;
  line-height: 0.75em;
  margin-bottom: 10px;
}

.bar-clock-ampm{
  font-size: 0.7em;
  margin-left: 5px;
}
.nyan-img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
/* .clock-design-nyan{
  font-family: "Maven Pro", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
}

.nyan-date {
  letter-spacing: 0.1em;
  font-size: 0.5em;
  margin-bottom: 14px;
  display: block;
  text-align: center;
  color: #8E3605;
  font-weight: bold;
}

.nyan-youbi {
  font-size: 0.5em;
  margin-left: 10px;
}

.nyan-time {
  letter-spacing: 0.06em;
  font-size: 0.5em;
  line-height: 0.75em;
  margin-bottom: 10px;
  color: #8E3605;
}

.nyan-icon-area{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 10px auto;
  padding: 0 12px;
  box-sizing: border-box;
}

.nyan-icon-1{
  width: 0.5em;
  height: 0.5em;
  background-color: #FDA43C;
  border-radius: 50%;
}

.nyan-icon-2{
  width: 0.5em;
  height: 0.5em;
  background-color: #E8B6FF;
  border-radius: 50%;
}

.nyan-icon-3{
  width: 0.5em;
  height: 0.5em;
  background-color: #3ADED4;
  border-radius: 50%;
} */

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
    text-align: left;
}

.modal-content {
  background-color: #fefefe;
  margin: 5vh auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 15px;
  width: 80%;

  max-width: 900px;
  min-height: 80vh;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.blog-area{
  padding: 20px;
  max-width: 620px;
  margin: 3rem auto;
  border-bottom: 1px solid #212121;
  border-top: 1px solid #212121;
}

.blog-area-title{
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.blog-area-row{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  margin-top: 24px;
}

.blog-area-thumb{
  flex: 0 0 auto;
  margin-right: 20px;
  width: 50%;
}

.blog-area-thumb img{
    object-fit: contain;
    width: 100%;
}

.blog-area-desc{
  width: 50%;
  word-wrap: break-word;
  font-size: 14px;
  letter-spacing: 2px;
  text-align: left;
}

.blog-area-desc a{
  text-decoration:none;
}

.blog-area-btn{
  margin-top:2rem;
}

.check-btn{
  background-color: #212121;
  opacity: 0.75;
  border-radius: 8px;
  padding: 5px 12px ;
  color: white;
  transition: all .5s;
}

.check-btn:hover{
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.35);
	transform: translateY(-4px);
}


</style>
